import type { ComponentType } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

export interface WithRouterProps {
  location: ReturnType<typeof useLocation>
  params: Record<string, string>
  navigate: ReturnType<typeof useNavigate>
}

export const withRouter = <T extends WithRouterProps>(Component: ComponentType<T>) =>
  // eslint-disable-next-line func-names
  function (props: Omit<T, keyof WithRouterProps>) {
    const location = useLocation()
    const params = useParams()
    const navigate = useNavigate()

    return <Component {...(props as T)} location={location} params={params} navigate={navigate} />
  }
